export const getAuthToken = (): string => {
  const authToken = localStorage.getItem("authInfo");
  return authToken as string;
};
